{
  "familyId": "TAA-SOORT-BNW",
  "questions": [
    {
      "id": "TAA-SOORT-BNW-001",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "text_highlight",
      "question": "Klik op het bijvoeglijk naamwoord in deze zin.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De grote hond rent door het park.",
        "correctHighlights": [{"start": 3, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijvoeglijk naamwoord herkennen",
            "content": "Een bijvoeglijk naamwoord (BNW) zegt iets over een zelfstandig naamwoord. Het geeft een eigenschap aan: hoe is iets? 'Grote' zegt iets over de hond (hoe is de hond? → groot).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {"dok": 1},
      "conceptId": "adjective_identify_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Grote' is het bijvoeglijk naamwoord. Het zegt iets over de hond: hoe is de hond? → groot.",
        "solutionSteps": [
          "Zoek het woord dat een eigenschap aangeeft",
          "'Grote' zegt iets over 'hond'",
          "Hoe is de hond? → groot",
          "'Grote' = bijvoeglijk naamwoord ✓"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BNW-002",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "text_highlight",
      "question": "Klik op alle bijvoeglijke naamwoorden in deze zin.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Het kleine, bruine konijn zit in een donker hol.",
        "correctHighlights": [{"start": 4, "end": 10}, {"start": 12, "end": 18}, {"start": 37, "end": 43}],
        "maxHighlights": 3
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meerdere BNW's herkennen",
            "content": "Zoek alle woorden die een eigenschap aangeven: 'kleine' (hoe is het konijn?), 'bruine' (welke kleur?), 'donker' (hoe is het hol?). Dat zijn 3 bijvoeglijke naamwoorden.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {"dok": 2},
      "conceptId": "adjective_count_multiple",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Er zijn 3 bijvoeglijke naamwoorden: 'kleine' (eigenschap van konijn), 'bruine' (kleur van konijn), en 'donker' (eigenschap van hol).",
        "solutionSteps": [
          "'Kleine' → eigenschap van konijn ✓",
          "'Bruine' → kleur van konijn ✓",
          "'Donker' → eigenschap van hol ✓",
          "Totaal: 3 bijvoeglijke naamwoorden"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BNW-003",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "text_highlight",
      "question": "Klik op het bijvoeglijk naamwoord. Let op: een bijwoord is géén bijvoeglijk naamwoord!",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De snelle auto reed snel voorbij.",
        "correctHighlights": [{"start": 3, "end": 9}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BNW vs. bijwoord",
            "content": "Een bijvoeglijk naamwoord staat bij een zelfstandig naamwoord: 'de snelle auto' (snelle = BNW bij auto). Een bijwoord staat bij een werkwoord: 'reed snel' (snel = bijwoord bij reed).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {"dok": 2},
      "conceptId": "adjective_vs_adverb",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Snelle' is het bijvoeglijk naamwoord — het zegt iets over de auto. 'Snel' in 'reed snel' is een bijwoord (het zegt iets over het werkwoord 'reed').",
        "solutionSteps": [
          "'De snelle auto' → 'snelle' zegt iets over 'auto' = BNW ✓",
          "'Reed snel' → 'snel' zegt iets over werkwoord = bijwoord ✗",
          "Alleen 'snelle' is het bijvoeglijk naamwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BNW-004",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "drag_drop_fill",
      "question": "Vul de juiste trap van vergelijking in.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "template": "Stellende trap: ___. Vergrotende trap: ___. Overtreffende trap: ___.",
        "blanks": [
          {"correctAnswer": "mooi", "position": 0},
          {"correctAnswer": "mooier", "position": 1},
          {"correctAnswer": "mooiste", "position": 2}
        ],
        "draggables": ["mooi", "mooier", "mooiste", "mooieren"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Trappen van vergelijking",
            "content": "Bijvoeglijke naamwoorden hebben 3 trappen: stellende trap (mooi), vergrotende trap (mooier, +er), overtreffende trap (mooiste, +ste). 'Mooieren' bestaat niet!",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {"dok": 1},
      "conceptId": "adjective_superlative",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De trappen zijn: mooi (stellend) → mooier (vergrotend, +er) → mooiste (overtreffend, +ste). 'Mooieren' bestaat niet — je combineert nooit -er en -en.",
        "solutionSteps": [
          "Stellende trap: mooi (basisvorm)",
          "Vergrotende trap: mooier (+er)",
          "Overtreffende trap: mooiste (+ste)",
          "'Mooieren' is een afleidwoord — bestaat niet"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BNW-005",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "matching",
      "question": "Koppel elk bijvoeglijk naamwoord aan de juiste trap van vergelijking.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "groot", "right": "stellende trap"},
          {"left": "groter", "right": "vergrotende trap"},
          {"left": "grootst", "right": "overtreffende trap"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Trappen van vergelijking",
            "content": "Stellende trap = basisvorm (groot). Vergrotende trap = +er (groter). Overtreffende trap = +st (grootst/grootste).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {"dok": 1},
      "conceptId": "adjective_comparison_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Groot = stellende trap (basisvorm), groter = vergrotende trap (+er), grootst = overtreffende trap (+st).",
        "solutionSteps": [
          "Groot → stellende trap (basisvorm)",
          "Groter → vergrotende trap (+er)",
          "Grootst → overtreffende trap (+st)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-BNW-006",
      "familyId": "TAA-SOORT-BNW",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_bijvoeglijk_nw",
      "questionType": "categorize",
      "question": "Sorteer de woorden in de juiste categorie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Bijvoeglijk naamwoord", "Zelfstandig naamwoord", "Werkwoord"],
        "items": [
          {"text": "mooi", "correctCategory": 0},
          {"text": "tafel", "correctCategory": 1},
          {"text": "rennen", "correctCategory": 2},
          {"text": "klein", "correctCategory": 0},
          {"text": "school", "correctCategory": 1},
          {"text": "springen", "correctCategory": 2}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordsoorten herkennen",
            "content": "Bijvoeglijk naamwoord (BNW) = hoe is iets? (mooi, klein). Zelfstandig naamwoord (ZNW) = een ding, dier of persoon (tafel, school). Werkwoord (WW) = wat doe je? (rennen, springen).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {"dok": 2},
      "conceptId": "adjective_categorize_mixed",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bijvoeglijke naamwoorden geven een eigenschap aan: mooi, klein. Zelfstandige naamwoorden zijn dingen: tafel, school. Werkwoorden zijn handelingen: rennen, springen.",
        "solutionSteps": [
          "Mooi → hoe is iets? → bijvoeglijk naamwoord",
          "Tafel → een ding → zelfstandig naamwoord",
          "Rennen → wat doe je? → werkwoord",
          "Klein → hoe is iets? → bijvoeglijk naamwoord",
          "School → een ding → zelfstandig naamwoord",
          "Springen → wat doe je? → werkwoord"
        ]
      }
    }
  ]
}